import { Injector } from '@angular/core';
import { PanelBarTemplate } from '../../../../../shared/expandable-panelbar/expandable-panelbar.component';
import { ToolingComponentPanelbar } from './tooling-component.panelbar';

export class ToolingComponentCategoryPanelbar extends PanelBarTemplate {
    constructor(private readonly injector: Injector) {
        super();
    }

    /**
     * 
     * @param dataItem 
     */
    setComponentCategoryData(dataItem: any) {
        this.reset();
        if (dataItem.Components.length > 0) {
            dataItem.Components.forEach(c => {
                c.ComponentCategory = dataItem;
                this.panelBars.push(this.getToolingComponentPanelbar(c));
            });
        }
    }

    /**
     * 
     * @param c 
     */
    private getToolingComponentPanelbar(c: any): ToolingComponentPanelbar {
        const pb = new ToolingComponentPanelbar(this.injector);
        let _pteName = '';
        if (c.ToolingItems.length > 0) _pteName = ` - ${c.ToolingItems[0].AssignedPTEName}`;
        pb.title = c.ComponentName + _pteName;
        pb.iconStack = false;
        pb.id = c.ComponentId;
        pb.iconClass = 'fa-puzzle-piece secondary-green';
        pb.setComponentData(c);
        return pb;
    }

}

